<template>
	<div>
		<small-header navbar-index=3></small-header>
		<header-banner></header-banner>
		<magic-content></magic-content>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import SmallHeader from '@/pages/common/SmallHeader'
	import HeaderBanner from '@/pages/common/HeaderBanner'
	import MagicContent from '@/pages/magic/components/MagicContent'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Magic',
		components: {
			SmallHeader,
			HeaderBanner,
			MagicContent,
			CommonFooter
		},
		data() {
			return {}
		},
		methods: {
			getDataInfo() {
				axios.get('/data.v01.json')
					.then(this.getDataInfoSucc)
			},
			getDataInfoSucc(res) {
				//				res = res.data
				res = res.data
				if(res.code == 100 && res.data) {
					const data = res.data
				}
			}
		},
		mounted() {
			this.getDataInfo()
		}
	};
</script>

<style lang="scss" scoped>

</style>